// extracted by mini-css-extract-plugin
export default {"key-pillars-holder":"KeyPillars_key-pillars-holder__UBcU8","key-pillar-card":"KeyPillars_key-pillar-card__5I13g","heading-holder":"KeyPillars_heading-holder__cPyyO"};